import { JobResultTypes, JobType } from '../../../api/jobs.dao';
import { IJobTriggerRunner, JobDtoType, RequestErrorType } from '../index';
import { JobRunner } from '../job-runner';

export class JobTriggerRunner extends JobRunner implements IJobTriggerRunner {
    public static create(type: JobType, jobResult: JobDtoType | RequestErrorType): JobTriggerRunner {
        const id = !Reflect.has(jobResult, 'jobId') ? null : (jobResult as JobDtoType).jobId;

        return new JobTriggerRunner(id, type, jobResult);
    }

    private readonly triggerDto: JobDtoType | RequestErrorType;

    public isTriggered(): boolean { return !!this.id; }
    public hasFailedTrigger(): boolean { return this.id === null; }

    public hasTriggerConflict(): boolean {
        return !!(
            this.hasFailedTrigger() &&
            (this.triggerDto as RequestErrorType)?.errorCode === 409
        );
    }

    public getResult(): JobResultTypes {
        if (this.hasFailedTrigger()) {
            return { failureReason: (this.triggerDto as RequestErrorType).errorMessage || null };
        }
        return super.getResult();
    }

    private constructor(id, type, jobResult) {
        super(id, type, jobResult);
        this.triggerDto = jobResult;
    }
}
